import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../CustomerScheme.css";
import { AWS_URL } from "../../Constant";

const CustomerLogin = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const clearEnrollmentCaches = () => {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (
        key === "customer_scheme_enrollment_cache" ||
        key.startsWith("customer_scheme_enrollment_cache_") ||
        key.startsWith("customer_scheme_enrollments_cache_")
      ) {
        localStorage.removeItem(key);
      }
    });
  };

  const getErrorMessage = (data, fallbackMessage) => {
    return data?.msg || data?.message || data?.error || fallbackMessage;
  };

  const resolveCustomerId = (data, phone) => {
    return (
      data?.data?._id ||
      data?._id ||
      data?.customer?._id ||
      data?.data?.customerMasterId ||
      data?.customerMasterId ||
      data?.data?.customerId ||
      data?.customerId ||
      data?.customer_id ||
      data?.customer?.id ||
      data?.customer?._id ||
      phone
    );
  };

  const resolveCustomerMasterId = (data) => {
    return (
      data?.data?.customerMasterId ||
      data?.customerMasterId ||
      data?.data?._id ||
      data?._id ||
      data?.customer?._id ||
      ""
    );
  };

  const resolveCustomerName = (data) => {
    return data?.customerName || data?.data?.customerName || data?.customer?.name || "";
  };

  const resolveUserType = (data) => {
    return data?.user_type || data?.data?.user_type || "CUSTOMER";
  };

  const resolvePhone = (data, phone) => {
    return data?.phone || data?.data?.phone || phone;
  };

  const resolveIsEnrolled = (data) => {
    const value = data?.isEnrolled;
    if (value === true || value === false) {
      return value;
    }
    const nested = data?.data?.isEnrolled;
    if (nested === true || nested === false) {
      return nested;
    }
    return false;
  };

  const sendOtp = async (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(mobile)) {
      setError("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      setSuccess("");

      const res = await fetch(`${AWS_URL}/customer/login/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: mobile }),
      });

      const data = await res.json();
      if (res.ok && data?.success !== false) {
        setOtpSent(true);
      } else {
        setOtpSent(false);
        setError(getErrorMessage(data, "Failed to send OTP."));
      }
    } catch {
      setError("Failed to send OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    if (!otp.trim()) {
      setError("Please enter OTP.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");
      setSuccess("");

      const res = await fetch(`${AWS_URL}/customer/login/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone: mobile, otp }),
      });

      const data = await res.json();
      if (!res.ok || data?.success === false) {
        setError(getErrorMessage(data, "OTP verification failed."));
        return;
      }

      const authPayload = {
        customerId: resolveCustomerId(data, mobile),
        customerMasterId: resolveCustomerMasterId(data) || resolveCustomerId(data, mobile),
        customerName: resolveCustomerName(data),
        phone: resolvePhone(data, mobile),
        mobile: resolvePhone(data, mobile),
        user_type: resolveUserType(data),
        isEnrolled: resolveIsEnrolled(data),
        accessToken: data?.access_token || data?.token || data?.data?.access_token || "",
        loginAt: new Date().toISOString(),
      };

      clearEnrollmentCaches();
      sessionStorage.setItem("customer_scheme_auth", JSON.stringify(authPayload));
      localStorage.removeItem("customer_scheme_auth");
      navigate("/customer/dashboard");
    } catch {
      setError("OTP verification failed.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="customer-scheme-shell">
      <div className="customer-scheme-container">
        <div className="customer-card customer-login-card">
          <div className="customer-header">
            <div>
              <h2>Customer Login</h2>
              <p className="customer-subtitle">Mobile + OTP login for scheme dashboard.</p>
            </div>
          </div>

          <form className="customer-form" onSubmit={otpSent ? verifyOtp : sendOtp}>
            <div className="customer-field">
              <label>Mobile Number</label>
              <input
                type="tel"
                maxLength={10}
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                placeholder="Enter 10-digit mobile"
                disabled={isLoading || otpSent}
              />
            </div>

            {otpSent && (
              <div className="customer-field">
                <label>OTP</label>
                <input
                  type="text"
                  maxLength={6}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  placeholder="Enter OTP"
                />
              </div>
            )}

            {error && <div className="customer-error">{error}</div>}
            {success && <div className="customer-success">{success}</div>}
            <div className="customer-row">
              {!otpSent ? (
                <button className="customer-btn customer-btn-primary" type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Send OTP"}
                </button>
              ) : (
                <button className="customer-btn customer-btn-primary" type="submit" disabled={isLoading}>
                  {isLoading ? "Verifying..." : "Verify & Continue"}
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CustomerLogin;
